import log from 'salvo-lite/log'

class Product {
    constructor (components) {
        this._name = this.constructor.name
        this._components = components
        this._headerHeight = document.querySelector('.site-header').offsetHeight
        this._counterBreakpoint = 0
    }

    onInit () {
        log.debug(this._name, 'Initializing', this)
        this._addEvents()
        log.debug(this._name, 'Initiated', this)
    }

    _addEvents () {
        log.debug(this._name, 'Adding Events')
        this._imageGalleryCounter()
    }

    _imageGalleryCounter () {
        const counter = document.querySelector('[data-image-counter]')
        const images = document.querySelectorAll(['[data-image-counter-image]'])
        window.addEventListener('scroll', () => this._imageGalleryCounterLogic(images, counter))
    }

    _imageGalleryCounterLogic (images, counter) {
        this._imageGalleryActiveImage(images, counter)
        this._imageGalleryCounterPosition(images, counter)
    }

    _imageGalleryActiveImage (images, counter) {
        let activeImage = 0
        images.forEach((image, i) => {
            const distanceFromTop = window.pageYOffset + image.getBoundingClientRect().top
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop
            if (scrollTop >= distanceFromTop - this._headerHeight) {
                activeImage = i
            }
        })
        activeImage += 1
        if (parseInt(counter.getAttribute('data-active-image')) !== activeImage) counter.setAttribute('data-active-image', activeImage)
    }

    _imageGalleryCounterPosition (images, counter) {
        const counterBottom = window.pageYOffset + counter.getBoundingClientRect().bottom
        const lastImageBottom = window.pageYOffset + images[(images.length - 1)].getBoundingClientRect().bottom

        if (counterBottom >= lastImageBottom - 40) {
            if (!counter.classList.contains('absolute')) {
                counter.classList.add('absolute')
                this._counterBreakpoint = window.pageYOffset
            }
        }

        if (window.pageYOffset < this._counterBreakpoint) {
            counter.classList.contains('absolute') && counter.classList.remove('absolute')
        }
    }
}

export default Product



// WEBPACK FOOTER //
// ./src/resources/scripts/pages/Product.js